var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6655_107621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09029 3C6.97913 3.03337 7.83882 3.32627 8.56295 3.84277C9.28717 4.35942 9.84462 5.07749 10.1655 5.90723C10.1871 5.96712 10.1871 6.03288 10.1655 6.09277C9.84462 6.92251 9.28717 7.64058 8.56295 8.15723C7.83882 8.67373 6.97913 8.96663 6.09029 9C5.20139 8.96639 4.34166 8.67304 3.61764 8.15625C2.8936 7.63943 2.33672 6.92157 2.01607 6.0918C1.99464 6.03214 1.99464 5.96689 2.01607 5.90723C2.33683 5.07774 2.89374 4.36037 3.61764 3.84375C4.34166 3.32712 5.20147 3.03353 6.09029 3ZM6.09029 3.54492C5.33151 3.58221 4.59854 3.83253 3.97506 4.2666C3.35155 4.70072 2.86222 5.30126 2.56393 6C2.86222 6.69874 3.35155 7.29928 3.97506 7.7334C4.59854 8.16747 5.33151 8.41779 6.09029 8.45508C6.84924 8.41794 7.58285 8.1675 8.2065 7.7334C8.82991 7.29933 9.31836 6.69863 9.61666 6C9.31836 5.30137 8.82991 4.70067 8.2065 4.2666C7.58285 3.8325 6.84924 3.58206 6.09029 3.54492ZM6.08932 4.36426C6.52295 4.36431 6.93884 4.53625 7.24557 4.84277C7.55238 5.14958 7.72506 5.56611 7.72506 6C7.72506 6.32357 7.62943 6.64014 7.44967 6.90918C7.26991 7.17819 7.01421 7.3879 6.71529 7.51172C6.41636 7.63554 6.08732 7.66761 5.76998 7.60449C5.45268 7.54138 5.16087 7.38597 4.93209 7.15723C4.70334 6.92848 4.54798 6.6366 4.48482 6.31934C4.42171 6.00202 4.45381 5.67294 4.5776 5.37402C4.70142 5.07509 4.9111 4.81941 5.18014 4.63965C5.44918 4.45988 5.76575 4.36426 6.08932 4.36426Z",
    fill: "#203662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6655_107621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 6,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow1);
export default __webpack_public_path__ + "static/media/Show1.4195b56e69e6ac0dc441b71402e39f45.svg";
export { ForwardRef as ReactComponent };